import React from "react";
import classNames from "~/lib/classNames";

export default ({ className, children, ...otherProps }) => (
    <h5 className={classNames("alert container", className)} {...otherProps}>
        {children}
    </h5>
);